type SimpleRule = {
  type: 'required' | 'email' | 'phoneNumber' | 'number';
  message: string;
};

type ValueRule = {
  type: 'minLength' | 'maxLength';
  value: number;
  message: string;
};

type PatternRule = {
  type: 'pattern';
  value: RegExp;
  message: string;
};

export type ValidationRule = SimpleRule | ValueRule | PatternRule;

export const validate = (
  value: string,
  rules: ValidationRule[]
): string | null => {
  for (const rule of rules) {
    if (rule.type !== 'required' && !value) {
      continue;
    }

    switch (rule.type) {
      case 'required':
        if (!value.trim()) {
          return rule.message;
        }
        break;

      case 'email':
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return rule.message;
        }
        break;

      case 'phoneNumber':
        if (!/^\+?[0-9\s-()]{7,15}$/.test(value)) {
          return rule.message;
        }
        break;

      case 'number':
        if (!/^\d+$/.test(value)) {
          return rule.message;
        }
        break;

      case 'minLength':
        if (value.length < rule.value) {
          return rule.message;
        }
        break;

      case 'maxLength':
        if (value.length > rule.value) {
          return rule.message;
        }
        break;

      case 'pattern':
        if (!rule.value.test(value)) {
          return rule.message;
        }
        break;

      default:
        return null;
    }
  }

  return null;
};

export const getValidationError = (
  value: any,
  validationKey: string,
  rules: { [key: string]: any[] } | undefined
): string | null => {
  if (!rules?.[validationKey]) {
    return null;
  }

  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }

  return validate(value, rules[validationKey]);
};
